import { useState, useEffect } from "react";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import api from "../../../api/Api";
import dayjs from "dayjs";
// import "./AssignSummary.css";

function AssignLogs() {

  const [logs, setLogs] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize] = useState(6);
  const [sortField, setSortField] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");

  const fetchLogs = (pageNo) => {
    api.post(
      "/api/assignments/logs",
      {
        search: search && search.trim() !== "" ? search : null
      },
      {
        params: {
          page: pageNo,
          size: pageSize,
          sort: `${sortField},${sortOrder}`,
        }
      }
    )
    .then((res) => {
      setLogs(res.data.response.content);
      setTotalPages(res.data.response.totalPages);
    })
    .catch((err) => {
      console.error("Error fetching logs:", err);
    });
  };

  useEffect(() => {
    fetchLogs(page);
  }, [page, sortField, sortOrder]);

  const handlePageChange = (event, value) => {
    setPage(value - 1);
    fetchLogs(value - 1);
  };

  // debounce search
  useEffect(() => {
    const delay = setTimeout(() => {
      setPage(0);
      fetchLogs(0);
    }, 200);
    return () => clearTimeout(delay);
  }, [search]);

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  const formatDate = (value) => {
    return value
      ? dayjs(value).format("DD MMM YYYY • hh:mm A")
      : "—";
  };

  const formatEventType = (value) => {
    if (!value) return "—";
    return value
      .split(",")
      .map(v => v.trim())
      .join(" , ");
  };

  return (
    <div className="container-fluid"
      style={{
        backgroundColor: "#f9f9f9",
        height: "100%",
        borderRadius: "20px",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >

      {/* Header */}
      <div className="d-flex justify-content-between align-items-center pt-3 flex-wrap">
        <h2 className="mb-2">Assignment Logs</h2>

        <input
          className="form-control rounded-pill p-3 mb-2"
          style={{ width: "60%", fontSize: "15px" }}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search employee / asset / notes..."
        />
      </div>

      {/* Table */}
      <div style={{ flex: 1, padding: "0 1rem", paddingTop: "25px" }}>

        <table className="table table-bordered table-hover shadow-sm">
          <thead className="table-primary">
            <tr>

              <th style={{ cursor: "pointer" }}
                onClick={() => handleSort("assetName")}>
                Asset {sortField === "assetName" ? (sortOrder === "asc" ? "↑" : "↓") : ""}
              </th>

              <th style={{ cursor: "pointer" }}
                onClick={() => handleSort("employeeName")}>
                Employee {sortField === "employeeName" ? (sortOrder === "asc" ? "↑" : "↓") : ""}
              </th>

              <th>Status</th>

              <th>Event</th>

              <th>Notes</th>

              <th style={{ cursor: "pointer" }}
                onClick={() => handleSort("createdAt")}>
                Changed On {sortField === "createdAt" ? (sortOrder === "asc" ? "↑" : "↓") : ""}
              </th>

              <th>Changed By</th>

            </tr>
          </thead>

          <tbody>
            {logs.length > 0 ? (
              logs.map((log, index) => (
                <tr key={index}>
                  
                  <td>{log.assetName}({log.assetId})</td>
                  <td>{log.employeeName}({log.employeeId})</td>

                  <td>
                    <span className={`badge ${
                      log.assignStatus === "ASSIGNED"
                        ? "bg-success"
                        : log.assignStatus === "UNASSIGNED"
                        ? "bg-danger"
                        : "bg-secondary"
                    }`}>
                      {log.assignStatus}
                    </span>
                  </td>

                  <td>
                    {formatEventType(log.eventType)}
                  </td>

                  <td>{log.notes || "—"}</td>

                  <td>{formatDate(log.createdAt)}</td>

                  <td>{log.createdBy || "—"}</td>

                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center text-muted">
                  No logs found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="d-flex justify-content-center mb-1">
        <Stack spacing={2}>
          <Pagination
            count={totalPages}
            page={page + 1}
            onChange={handlePageChange}
            color="primary"
            shape="rounded"
            variant="outlined"
          />
        </Stack>
      </div>

    </div>
  );
}

export default AssignLogs;
